import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './AdminLogin.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      console.log('Intentando login con:', email);
      const res = await api.post('/api/auth/login', { email, password });
      console.log('Respuesta del servidor:', res.data);
      if (res.data.success) {
        localStorage.setItem('adminToken', res.data.token);
        navigate('/admin/panel');
      } else {
        setError(res.data.message || 'Error al iniciar sesión');
      }
    } catch (err) {
      console.error('Error en login:', err);
      const errorMessage = err.response?.data?.message || 
                          err.message || 
                          'Error al conectar con el servidor. Verifica que el backend esté corriendo.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="login-card">
        <h1>Multicentro Comercial Virtual</h1>
        <p className="subtitle">Panel de administración</p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          {error && <p className="error">{error}</p>}
          <button type="submit" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
        <p className="hint">Por defecto: admin@multicentro-comercial.es / Admin123</p>
        <a href="/" className="back-link">← Volver al Globe</a>
      </div>
    </div>
  );
};

export default AdminLogin;
